<template>
  <section>
    <el-row>
      <el-col :span="3" >
        <el-autocomplete placeholder="input factory"
                         :trigger-on-focus="false"
                         v-model="searchcmKey"
                         :fetch-suggestions="doCmSearch"
                         @select="handleSelect"
                         prefix-icon="el-icon-fa-search">
          <template slot-scope="{ item }">
            <div class="name" style="color:green">{{ item.value=item.CmName }}</div>
          </template>
        </el-autocomplete>
      </el-col>

      <el-col :span="3" :offset="1">
        <el-autocomplete placeholder="input ref.no." v-model="searchKey" prefix-icon="el-icon-fa-search"
                         :trigger-on-focus="false"
                         :fetch-suggestions="doPoSearch"
                         @select="handlePoSelect">
          <template slot-scope="{ item }">
            <div class="name" style="color:green">{{ item.value=item.Value }}</div>
          </template>
        </el-autocomplete>
      </el-col>

      <el-col :span="3" :offset="1">
        <el-date-picker v-model="searchdate" type="date" placeholder="PRODUCTION DATE" format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd">

        </el-date-picker>

      </el-col>

      <el-col :span="3" :offset="2">
        <el-button type="primary" icon="el-icon-fa-search"
                   @click=" pager.pager.pageNumber = 1 ;doSearch()"></el-button>
      </el-col>

    </el-row>

    <el-table :data="pager.dataList" border stripe style="width: 100%">

      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="cm-table-expand">
            <el-form-item label="OVER / SHORT CUT-ORD QTY (-)">
              <span>{{ props.row.cutLeft }}</span>
            </el-form-item>
            <el-form-item label="BALANCE OR EXCESS SEWING">
              <span>{{ props.row.SewLeft }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column prop="id" label="ID" head-align="center" align="center" width="40"></el-table-column>
      <el-table-column prop="cCompanySName" label="FACTORY" show-overflow-tooltip head-align="center" width ="100" align="center"></el-table-column>
      <el-table-column prop="RefNo" label="REF#" show-overflow-tooltip head-align="center"  width ="100" align="center"></el-table-column>
      <el-table-column prop="StyleNo" label="Style.No." show-overflow-tooltip head-align="center" width ="80" align="center"></el-table-column>
      <el-table-column prop="PONo" label="Po.No." show-overflow-tooltip head-align="center" width ="80" align="center"></el-table-column>
      <el-table-column prop="EColor" label="Color" show-overflow-tooltip head-align="center" min-width ="120" align="center"></el-table-column>
      <el-table-column prop="TotalQty" label="ORDER QTY(PCS)" show-overflow-tooltip head-align="center" width ="80" align="center"></el-table-column>

      <el-table-column  prop="PrdDate" :formatter="formatRecdate" label="PRODUCTION.DATE" show-overflow-tooltip head-align="center" align="center" width="100">
       <!-- <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="PrdDate">
              <el-date-picker size="small" v-model="scope.row.PrdDate" type="date"  placeholder="PRD DATE" format="yyyy-MM-dd"
                              value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
          </el-form>
        </template>
        -->
      </el-table-column>

      <el-table-column  label="TTL CUTTING" show-overflow-tooltip head-align="center" width ="80" align="center">
        <template slot-scope="props">
          <div v-if="props.row.ttlcut>0"><span>{{props.row.ttlcut}}</span></div>
          <div v-else><span>{{props.row.ottlcut}}</span></div>
        </template>
      </el-table-column>

      <el-table-column label="TODAY CUTTING (PCS)" show-overflow-tooltip head-align="center" width ="120" align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="CutQty">
              <el-input  v-show="true" size="small" v-model="scope.row.CutQty" @change="onCutChange(scope.row)" style="width:80px"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column label="CUTTING STATUS" show-overflow-tooltip head-align="center" width ="110"  align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="CutStatus">
              <el-select v-model="scope.row.oCutStatus" placeholder="select">
                <el-option
                  v-for="item in sewoptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column  label="TODAY INPUT" show-overflow-tooltip head-align="center" width ="100" align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="InputQty">
              <el-input  v-show="true" size="small" v-model="scope.row.InputQty" @change="onInputChange(scope.row)" style="width:80px"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column label="TTL INPUT(PCS)" show-overflow-tooltip head-align="center" width ="100"  align="center">
        <template slot-scope="props">
          <div v-if="props.row.ttlinput>0"><span>{{ props.row.ttlinput }}</span></div>
          <div v-else><span>{{ props.row.ottlinput }}</span></div>
        </template>
      </el-table-column>

      <el-table-column label="UNTIL TODAY TTL SEWING(PCS)" show-overflow-tooltip head-align="center" width ="100"  align="center">
        <template slot-scope="props">
          <div v-if="props.row.ttlSew>0"><span>{{props.row.ttlSew}}</span></div>
          <div v-else><span>{{props.row.ottlSew}}</span></div>
        </template>
      </el-table-column>

      <el-table-column  label="TODAY SEWING OUTPUT(PCS)" show-overflow-tooltip head-align="center" width ="100"  align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="SewQty">
              <el-input v-show="true" size="small" v-model="scope.row.SewQty" @change="onSewChange(scope.row)" style="width:80px"></el-input>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column label="SEWING STATUS" show-overflow-tooltip head-align="center" width ="110"  align="center">
        <template slot-scope="scope">
          <el-form :model="scope.row" :rules="$rules" ref="scope.row" >
            <el-form-item prop="SewStatus">
              <el-select v-model="scope.row.oSewStatus" placeholder="select">
                <el-option
                  v-for="item in sewoptions"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>

      <el-table-column label="SAVE" show-overflow-tooltip header-align="center" width ="60" align="center">
        <template slot-scope="scope">
          <el-button-group>
            <el-button title="RCV Fabric" size="mini" type="primary" icon="el-icon-fa-edit"
                       @click="handleEdit(scope.$index,scope.row)"></el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <el-row>
      <el-col :span="6" :offset="18">
        <el-pagination background small style="float:right" layout="prev, pager, next"
                       :total="pager.pager.recordCount" :page-size="pager.pager.pageSize"
                       :current-page.sync="pager.pager.pageNumber" v-show="pager.pager.pageCount != 0"
                       @current-change="doSearch">
        </el-pagination>
      </el-col>
    </el-row>


  </section>

</template>
<style>
  .cm-table-expand {
    font-size: 0;
  }
  .cm-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .cm-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
  .el-form-item {
    margin-bottom: 0;
  }
  .el-form-item .el-form-item__label{
    width: 50%;
  }
  .el-table .cell.el-tooltip {
    white-space: pre-wrap;
    max-lines: 2;
  }
</style>

<script>
  import ElCol from "element-ui/packages/col/src/col";
  export default {
    components: {ElCol},
    data() {
      return {
        searchKey: "",
        searchcmKey: "",
        searchdate: this.getlastDay(),
        pager: {
          pager: {
            pageCount: 0,
            pageNumber: 1,
            pageSize: 15,
            recordCount: 0
          }
        },
        cms: [],
        orders: [],
        selected: [],
        addEditShow: false,
        onloading: false,
        config: {
        },
        copyedconfig:{
        },
        formLabelWidth: "120px",
        options: ['FINISH','PARTIAL','SHORT','CANCELL'],
        sewoptions:['FINISH','BALANCE','PARTIAL','CANCELL']
      };
    },
    computed: {
      dialogWidth() {
        return 590 * 100 / this.$utils.windowWidth() + "%";
      }
    },
    watch: {
      options: function () {
        this.selected = [];
        this.options.forEach(item => {
          if (item.selected) {
            this.selected.push(item.key);
          }
        });
      }
    },
    methods: {
      getlastDay(){

        var date = new Date();

        date.setDate(date.getDate()-1);

        var m = date.getMonth();
        var day = date.getDate();

        m = m + 1;
        if(day < 10)
          day = "0"+day;
        if(date.getMonth()<9) {
          return date.getFullYear() + "-0" + m + "-" + day;
        }
        else
          return date.getFullYear()+"-"+m+"-"+day;
      },
      changePage() {
        if (this.searchKey) {
          this.doSearch();
        } else {
          this.loadData();
        }
      },
      doSearch() {


        if(this.searchdate == undefined || this.searchdate.length != 10){
          this.$message("please select production date!");
          return;
        }
        this.$api.CmProduction.search(
          this.pager.pager.pageNumber,
          this.searchcmKey+"#"+this.searchKey+"#"+this.searchdate,
          result => {
            this.pager = result.pager;

          }
        );
      },

      doPoSearch(queryString,callback){


        if(queryString != undefined && queryString.length >= 2) {

          if(this.checkonloading())
              return;
          this.orders = [];

          if (this.orders == undefined || this.orders.length == 0) {
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
            this.$api.CmProduction.searchpo(
              1,
              queryString,
              result => {
                this.orders = result.pager;
                if(this.orders.length == 0){
                  this.orders.push({Value: "NOT FOUND",
                    iCompanySn: "A0001",
                    id: -1});
                }
                 callback(this.orders);
              }
              );
            }, 1300)
          }
        }
      },
      goPopUp(queryString,callback){
        let list = [];

        for(let ob in this.cms){
          if(this.cms[ob].CmName.toLowerCase().indexOf(queryString.toLowerCase()) >= 0){
            list.push(this.cms[ob]);
          }
        }
        if(list.length == 0){
          list.push({CmName: "NOT FOUND",
            iCompanySn: "A0001",
            id: -1});
        }

        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          callback(list);
        }, 1000);
      },
      doCmSearch(queryString,callback){

        if(this.cms == undefined || this.cms.length ==0) {

          if(this.checkonloading())
            return;

          clearTimeout(this.timeout);

          this.timeout = setTimeout(() => {
            this.$api.CmProduction.searchcm(
              1,
              "",
              result => {
                this.cms = result.pager;
                //this.searchcmKey = this.cms[2].CmName;
                //this.$http.loadinginstace.close();
                if(this.cms != undefined && this.cms.length > 0)
                  this.goPopUp(queryString,callback);
              }
            );
          },1200);
        }
        if(this.cms != undefined && this.cms.length > 0)
          this.goPopUp(queryString,callback);
      },

      handlePoSelect(item){
          if(item.id != -1)
            this.searchKey = item.value;
          else
            this.searchKey = "";
      },
      handleSelect(item){
          if(item.id != -1)
              this.searchcmKey = item.value;
          else
            this.searchcmKey = "";
      },
      saveOrUpdate(formName) {
        this.$refs[formName].validate(valid => {
          if (valid) {
            var callback = result => {
              this.changePage();
              this.addEditShow = false;
            };
            this.$api.CmProduction.update(this.config, callback)

          } else {
            return false;
          }
        });
      },
      handleEdit(index, row) {

        if(row.PrdDate == null){

          this.$message({
            showClose: true,
            message:"PLEASE SELECT PRD.DATE, PRODUCTION CAN'T BE EMPTY?",
            type: "error"
          });
          return;
        }
        this.config = row;

        if(this.config.ttlcut == undefined || this.config.ttlcut == 0){
          this.config.ttlcut = this.config.ottlcut;
        }
        if(this.config.ttlSew == undefined || this.config.ttlSew == 0){
          this.config.ttlSew = this.config.ottlSew;
        }

        if(this.config.ttlinput == undefined || this.config.ttlinput == 0){
          this.config.ttlinput = this.config.ottlinput;
        }

        //this.copyedconfig = {...this.config};
        //this.addEditShow = true;
        var callback = result => {
          //this.changePage();
          if(result.cmProcution != undefined) {
            //var cmProcution = result.cmProcution;
            row.id = result.cmProcution.id;
            //this.searchKey = cmProcution.id;
          }
          this.addEditShow = false;
        };
        this.config.iCmProcutionSn = "000";
        this.config.SewStatus = this.config.oSewStatus;
        this.config.CutStatus = this.config.oCutStatus;
        if(this.config.id == 0 || this.config == null)
          this.$api.CmProduction.save(this.config, callback);
        else
          this.$api.CmProduction.update(this.config, callback)
      },
      cancelEdit(){
        this.addEditShow = false;
      },
      formatRecdate(row ,column){

        if(row.PrdDate === "" || row.PrdDate == null){

          return "";
        }else{

          return  row.PrdDate.substr(0,10);
        }
      },
      onCutChange(config){
          if(config.CutQty == "" || config.CutQty == null) return;
        config.ttlcut = parseInt(config.ottlcut) + parseInt(config.CutQty) - parseInt(config.BackupCutQty);
        if(parseInt(config.ttlcut) >= parseInt(config.TotalQty)) {
          config.CutStatus = "FINISH";
          config.oCutStatus = "FINISH";
        }
        config.PrdDate = this.searchdate;
        config.cutLeft = config.ttlcut - config.TotalQty;

      },
      onSewChange(config){
        if(config.SewQty == "" || config.SewQty == null) return;
        config.ttlSew = parseInt(config.ottlSew) + parseInt(config.SewQty) - parseInt(config.BackupSewQty);
        if(parseInt(config.ttlSew) >= parseInt(config.TotalQty)) {
          config.SewStatus = "FINISH";
          config.oSewStatus = "FINISH";
        }
        config.PrdDate = this.searchdate;
        if(config.ttlinput > 0 )
          config.SewLeft = config.ttlSew - config.ttlinput;
        else
          config.SewLeft = config.ttlSew - config.ottlinput;
      },
      onInputChange(config){
          if(config.InputQty == "" || config.InputQty == null) return;
        config.ttlinput = parseInt(config.ottlinput) + parseInt(config.InputQty) - parseInt(config.BackupInputQty);
      },
      checkonloading(){

        if (this.$http.loadinginstace && this.$http.loadinginstace.visible)
            return true;
        else
            return false;
      },
      onStatusChange(){

      },
      handleDelete(index, row) {
        this.$confirm("确认删除账号?", "删除确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$api.WxConfig.delete(row.id, result => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            window.setTimeout(() => {
              this.changePage();
            }, 2000);
          });
        });
      },
      loadData() {
        this.$api.CmProduction.list(this.pager.pager.pageNumber, result => {
          this.pager = result.pager;
        });
      }
    },
    created: function () {
      //this.doCmSearch();
      this.doSearch();
    }
  };
</script>



// WEBPACK FOOTER //
// src/views/order/CmProduction.vue